import Sortable from "@stimulus-components/sortable"
import { FetchRequest } from "@rails/request.js"

export default class extends Sortable {
  static values = {
    cachedProductsIds: Array,
    updateUrl: String,
  }

  static targets = ["list", "item"]


  itemTargetConnected(element) {
    if (!this.cachedProductsIdsValue.includes(parseInt(element.dataset.id, 10))) {
      const cachedProductsIds = this.cachedProductsIdsValue
      cachedProductsIds.unshift(parseInt(element.dataset.id, 10))
      this.cachedProductsIdsValue = cachedProductsIds

      this.requestChange()
    }
  }

   onUpdate({ newIndex, oldIndex, item }) {
    const cachedProductsIds = this.cachedProductsIdsValue
    cachedProductsIds.splice(newIndex, 0, cachedProductsIds.splice(oldIndex, 1)[0])
    this.cachedProductsIdsValue = cachedProductsIds

    this.requestChange()
  }

  removeItem({ params: { productDomId, productId } }) {
    const item = this.itemTargets.find((element) => element.id === productDomId)

    if (item) {
      const cachedProductsIds = this.cachedProductsIdsValue
      const index = cachedProductsIds.indexOf(parseInt(productId, 10))

      if (index > -1) {
        cachedProductsIds.splice(index, 1)
        this.cachedProductsIdsValue = cachedProductsIds
      }

      item.remove()

      this.requestChange()
    }
  }

  requestChange() {
    const request = new FetchRequest("patch", this.updateUrlValue, {
      body: JSON.stringify({ seo_page: { cached_products_ids: this.cachedProductsIdsValue } })
    })
    return request.perform()
  }
}
